import { api } from "@/client/api"

export default {
    proveSendSms(mobilePhone, ssnLast4) {
        return api.post("identity-verification/prove/send-sms", { mobilePhone, ssnLast4 })
    },
    proveResendSms() {
        return api.post("identity-verification/prove/resend-sms")
    },
    getProveSmsStatus() {
        return api.get("identity-verification/prove/sms-status")
    },
    getProveVerificationResult() {
        return api.get("identity-verification/prove/verification-result")
    },
}
